export const COD_CONSULTORIO_VIRTUAL = 6;

/** Rótulo do Consultório Virtual nas trocas de unidade ("A ⇄ B"). */
export const CONSULTORIO_VIRTUAL_LABEL = "Consultório Virtual";

export const isConsultorioVirtual = (codUnidade: number): boolean => {
  return codUnidade === COD_CONSULTORIO_VIRTUAL;
};

export const canScheduleOnSundayInUnit = ({
  codUnidade,
  permiteAgendarNoDomingo,
  ignoraFeriadosNoConsultorioVirtual,
}: {
  codUnidade: number;
  permiteAgendarNoDomingo: boolean;
  ignoraFeriadosNoConsultorioVirtual: boolean;
}): boolean => {
  return isConsultorioVirtual(codUnidade)
    ? ignoraFeriadosNoConsultorioVirtual
    : permiteAgendarNoDomingo;
};
